import * as echarts from 'echarts';

function formatUGX(value) {
  return 'UGX ' + Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function renderRevenueOverview() {
  var el = document.getElementById('revenue-overview-chart');
  if (!el || typeof gon === 'undefined' || !gon.revenue_labels) return;
  if (echarts.getInstanceByDom(el)) return;

  var chart = echarts.init(el);
  window.addEventListener('resize', function () { chart.resize(); });

  chart.setOption({
    grid: { left: 10, right: 16, top: 20, bottom: 10, containLabel: true },
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        var p = params[0];
        return p.name + '<br/><strong>' + formatUGX(p.value) + '</strong>';
      }
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: gon.revenue_labels,
      axisTick: { show: false },
      axisLine: { lineStyle: { color: '#e9edf2' } },
      axisLabel: { color: '#64748b', fontSize: 11 }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        color: '#64748b',
        fontSize: 11,
        formatter: function (value) {
          return value >= 1000 ? (value / 1000) + 'k' : value;
        }
      },
      splitLine: { lineStyle: { color: '#f1f5f9' } }
    },
    series: [{
      name: 'Revenue',
      type: 'line',
      smooth: true,
      symbol: 'circle',
      symbolSize: 7,
      data: gon.revenue_data,
      itemStyle: { color: '#16a34a' },
      lineStyle: { color: '#16a34a', width: 3 },
      areaStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: 'rgba(22, 163, 74, 0.25)' },
          { offset: 1, color: 'rgba(22, 163, 74, 0.02)' }
        ])
      }
    }]
  });
}

function renderSixMonthRevenue() {
  var el = document.getElementById('six-month-revenue-chart');
  if (!el || typeof gon === 'undefined' || !gon.six_month_labels) return;
  if (echarts.getInstanceByDom(el)) return;

  var chart = echarts.init(el);
  window.addEventListener('resize', function () { chart.resize(); });

  chart.setOption({
    grid: { left: 10, right: 16, top: 20, bottom: 10, containLabel: true },
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: function (params) {
        var p = params[0];
        return p.name + '<br/><strong>' + formatUGX(p.value) + '</strong>';
      }
    },
    xAxis: {
      type: 'category',
      data: gon.six_month_labels,
      axisTick: { show: false },
      axisLine: { lineStyle: { color: '#e9edf2' } },
      axisLabel: { color: '#64748b', fontSize: 11 }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        color: '#64748b',
        fontSize: 11,
        formatter: function (value) {
          return value >= 1000 ? (value / 1000) + 'k' : value;
        }
      },
      splitLine: { lineStyle: { color: '#f1f5f9' } }
    },
    series: [{
      name: 'Revenue',
      type: 'bar',
      barMaxWidth: 42,
      data: gon.six_month_totals,
      itemStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: '#22c55e' },
          { offset: 1, color: '#16a34a' }
        ]),
        borderRadius: [6, 6, 0, 0]
      },
      emphasis: {
        itemStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#4ade80' },
            { offset: 1, color: '#15803d' }
          ])
        }
      }
    }]
  });
}

function renderSixWeekRevenue() {
  var el = document.getElementById('six-week-revenue-chart');
  if (!el || typeof gon === 'undefined' || !gon.six_week_labels) return;
  if (echarts.getInstanceByDom(el)) return;

  var chart = echarts.init(el);
  window.addEventListener('resize', function () { chart.resize(); });

  chart.setOption({
    grid: { left: 10, right: 16, top: 20, bottom: 10, containLabel: true },
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: function (params) {
        var p = params[0];
        return p.name + '<br/><strong>' + formatUGX(p.value) + '</strong>';
      }
    },
    xAxis: {
      type: 'category',
      data: gon.six_week_labels,
      axisTick: { show: false },
      axisLine: { lineStyle: { color: '#e9edf2' } },
      axisLabel: { color: '#64748b', fontSize: 11 }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        color: '#64748b',
        fontSize: 11,
        formatter: function (value) {
          return value >= 1000 ? (value / 1000) + 'k' : value;
        }
      },
      splitLine: { lineStyle: { color: '#f1f5f9' } }
    },
    series: [{
      name: 'Revenue',
      type: 'bar',
      barMaxWidth: 42,
      data: gon.six_week_totals,
      itemStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: '#60a5fa' },
          { offset: 1, color: '#2563eb' }
        ]),
        borderRadius: [6, 6, 0, 0]
      },
      emphasis: {
        itemStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#93c5fd' },
            { offset: 1, color: '#1d4ed8' }
          ])
        }
      }
    }]
  });
}

function renderMonthlyByHotspot() {
  var el = document.getElementById('monthly-hotspot-chart');
  if (!el || typeof gon === 'undefined' || !gon.monthly_hotspot_series) return;
  if (echarts.getInstanceByDom(el)) return;

  var chart = echarts.init(el);
  window.addEventListener('resize', function () { chart.resize(); });

  var series = gon.monthly_hotspot_series.map(function (hotspot) {
    return {
      name: hotspot.name,
      type: 'bar',
      stack: 'revenue',
      barMaxWidth: 18,
      emphasis: { focus: 'series' },
      data: hotspot.data
    };
  });

  chart.setOption({
    color: ['#16a34a', '#3b82f6', '#8b5cf6', '#f59e0b', '#ef4444',
            '#06b6d4', '#ec4899', '#84cc16', '#64748b', '#a855f7'],
    grid: { left: 10, right: 16, top: 46, bottom: 10, containLabel: true },
    legend: {
      type: 'scroll',
      top: 0,
      left: 0,
      icon: 'circle',
      itemWidth: 9,
      itemHeight: 9,
      textStyle: { color: '#64748b', fontSize: 11 }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: function (params) {
        var total = 0;
        var rows = params.filter(function (p) { return p.value > 0; }).map(function (p) {
          total += p.value;
          return p.marker + ' ' + p.seriesName + ': <strong>' + formatUGX(p.value) + '</strong>';
        });
        if (!rows.length) return params[0].name + '<br/>No revenue';
        return params[0].name + '<br/>' + rows.join('<br/>') +
          '<br/><hr style="margin:4px 0;border-color:#e9edf2"/>Total: <strong>' + formatUGX(total) + '</strong>';
      }
    },
    xAxis: {
      type: 'category',
      data: gon.monthly_labels,
      axisTick: { show: false },
      axisLine: { lineStyle: { color: '#e9edf2' } },
      axisLabel: { color: '#64748b', fontSize: 11 }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        color: '#64748b',
        fontSize: 11,
        formatter: function (value) {
          return value >= 1000 ? (value / 1000) + 'k' : value;
        }
      },
      splitLine: { lineStyle: { color: '#f1f5f9' } }
    },
    series: series
  });
}

function renderHotspotPerformance() {
  var el = document.getElementById('hotspot-performance-chart');
  if (!el || typeof gon === 'undefined' || !gon.five_month_hotspot_series) return;
  if (echarts.getInstanceByDom(el)) return;

  var chart = echarts.init(el);
  window.addEventListener('resize', function () { chart.resize(); });

  var series = gon.five_month_hotspot_series.map(function (hotspot) {
    return {
      name: hotspot.name,
      type: 'bar',
      barMaxWidth: 26,
      emphasis: { focus: 'series' },
      data: hotspot.data
    };
  });

  chart.setOption({
    color: ['#16a34a', '#3b82f6', '#8b5cf6', '#f59e0b', '#ef4444',
            '#06b6d4', '#ec4899', '#84cc16', '#64748b', '#a855f7'],
    grid: { left: 10, right: 16, top: 46, bottom: 10, containLabel: true },
    legend: {
      type: 'scroll',
      top: 0,
      left: 0,
      icon: 'circle',
      itemWidth: 9,
      itemHeight: 9,
      textStyle: { color: '#64748b', fontSize: 11 }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: function (params) {
        var rows = params.filter(function (p) { return p.value > 0; }).map(function (p) {
          return p.marker + ' ' + p.seriesName + ': <strong>' + formatUGX(p.value) + '</strong>';
        });
        if (!rows.length) return params[0].name + '<br/>No revenue';
        return params[0].name + '<br/>' + rows.join('<br/>');
      }
    },
    xAxis: {
      type: 'category',
      data: gon.five_month_labels,
      axisTick: { show: false },
      axisLine: { lineStyle: { color: '#e9edf2' } },
      axisLabel: { color: '#64748b', fontSize: 11 }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        color: '#64748b',
        fontSize: 11,
        formatter: function (value) {
          return value >= 1000 ? (value / 1000) + 'k' : value;
        }
      },
      splitLine: { lineStyle: { color: '#f1f5f9' } }
    },
    series: series
  });
}

function renderDonut(elementId, data, palette) {
  var el = document.getElementById(elementId);
  if (!el || !data || !data.length) return;
  if (echarts.getInstanceByDom(el)) return;

  var chart = echarts.init(el);
  window.addEventListener('resize', function () { chart.resize(); });

  chart.setOption({
    color: palette,
    tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
    series: [{
      type: 'pie',
      radius: ['68%', '92%'],
      avoidLabelOverlap: false,
      label: { show: false },
      labelLine: { show: false },
      data: data
    }]
  });
}

$(document).ready(function () {
  renderRevenueOverview();
  renderSixMonthRevenue();
  renderSixWeekRevenue();
  renderMonthlyByHotspot();
  renderHotspotPerformance();

  if (typeof gon !== 'undefined') {
    renderDonut('vouchers-summary-chart', gon.vouchers_summary,
      ['#22c55e', '#3b82f6', '#8b5cf6', '#f59e0b']);
    renderDonut('payment-methods-chart', gon.payment_methods,
      ['#22c55e', '#ef4444', '#f59e0b', '#94a3b8']);
  }
});
